<template>
    <div class="pdf-page-indicator">
        <span v-if="label">{{ label }}</span>
        <primevue-input-number
            v-model.number="pageInputValue"
            class="page-number-input"
            :input-id="inputId"
            :min="1"
            :max="totalPages"
            :use-grouping="false"
            aria-label="Current page"
            @change="handlePageChange"
            @keydown.enter="handlePageChange"
        />
        <span>{{ totalPrefix }} {{ totalPages }}</span>
    </div>
</template>

<script setup lang="ts">
import { ref, watch } from 'vue';
import PrimevueInputNumber from 'primevue/inputnumber';

const props = withDefaults(defineProps<{
    currentPage: number;
    totalPages: number;
    inputId: string;
    label?: string;
    totalPrefix?: string;
}>(), {
    label: '',
    totalPrefix: '/',
});

const emit = defineEmits<{ 'page-change': [number] }>();
const pageInputValue = ref<number>(props.currentPage);

watch(() => props.currentPage, currentPage => {
    pageInputValue.value = currentPage;
});

function handlePageChange (): void {
    const page = Math.min(Math.max(pageInputValue.value, 1), props.totalPages);
    pageInputValue.value = page;
    emit('page-change', page);
}
</script>

<style scoped lang="scss">
.pdf-page-indicator {
    display: inline-flex;
    align-items: center;
    gap: 0.25rem;
    color: var(--secondaryFont);
    font-size: var(--smallFontSize);
    white-space: nowrap;
}

.page-number-input {
    flex: 0 0 4rem;
    min-width: 4rem;
    width: 4rem;

    :deep(input) {
        width: 100%;
    }
}
</style>
